<template>
  <div class="micro-chat">
    <div class="chat-content">
      <div class="chat-content-left" v-loading="isLoading" v-if="!isLoading">
        <div class="chat-header">
          联系人列表
          <p class="chat-header-invite" v-if="loginInfouser.personType === 'STAFF'" @click="showYQDialog=true">邀请</p>
        </div>
        <ul class="chat-content-list" ref="chatContentList" id="chatContentList">
          <!-- 群聊列表 -->
          <li @click="openChatWindow(allDataList)"
              :class="['chat-single-list', {'select-single-list': currentRoomId === allDataList.roomId} ]">
            <p class="single-list-top">
              <span class="single-top-name">案件空间({{ groupMemberCount }}人)</span>
              <span v-if="groupChatList.lastMessageContent"
                    class="single-top-time">{{ groupChatList.lastMessageTime | dateFormat }} </span>
            </p>
            <p class="single-list-bottom single-flex">
              <span v-if="groupChatList.unreadMessageCount"
                    class="single-bottom-number">{{ groupChatList.unreadMessageCount }}</span>
              <span class="single-bottom-groupmsgname">{{ groupChatList.memberName }}
                            <span v-if="groupChatList.lastMessageContent">:</span>
                        </span>
              <span class="single-bottom-groupmsg" v-if="groupChatList.categoryBig === 'DOCUMENT'">
                            发送了《{{ groupChatList.lastMessageContent }}》
                        </span>
              <span class="single-bottom-groupmsg" v-else-if="groupChatList.categoryBig === 'VOICE'">
                            语音信息
                        </span>
              <span class="single-bottom-groupmsg" v-else-if="groupChatList.categoryBig === 'TEXT'">
                            文本信息
                        </span>
              <span class="single-bottom-groupmsg" v-else>
                            <!-- {{groupChatList.lastMessageContent}} -->
                            暂无消息
                        </span>
            </p>
          </li>
          <li v-for="(item, index) in singleChatLists" :key="index"
              :class="['chat-single-list', {'select-single-list': currentRoomId === item.roomId} ]"
              @click="openChatWindow(item)">
            <div class="chat-single-outer">
              <div class="chat-single-le">
                <template>
                  <img class="single-top-avatar"
                       v-if="memberHeaderUrl[item.memberId] && memberHeaderUrl[item.memberId].headPortraitUrl"
                       :src="memberHeaderUrl[item.memberId].headPortraitUrl" alt="">
                  <img class="single-top-avatar" src="@/assets/casespace/avatar_default.png" v-else/>
                </template>
              </div>
              <div class="chat-single-ri">
                <div class="single-list-top">
                  <div class="single-list-topinner">
                    <span class="single-top-name">{{ item.memberName }}</span>
                    <span class="single-top-real" v-if="item.isFacialVerify">已认证</span>
                    <span class="single-top-noreal" v-else>未认证</span>
                  </div>
                  <span v-if="item.lastMessageContent"
                        class="single-top-time">{{ item.lastMessageTime | dateFormat }}</span>
                </div>
                <p class="single-list-bottom single-list-bottom1">
                  <span v-if="item.unreadMessageCount" class="single-bottom-number">{{ item.unreadMessageCount }}</span>
                  <span class="single-bottom-msg" v-if="item.messageResource === 'INVITATION_VIDEO'">向你发起了在线庭审</span>
                  <span class="single-bottom-msg" v-else-if="item.categoryBig === 'VOICE'">语音信息</span>
                  <span class="single-bottom-msg" v-else-if="item.categoryBig === 'IMG'">图片信息</span>
                  <span class="single-bottom-msg" v-else-if="item.categoryBig === 'VIDEO'">视频信息</span>
                  <span class="single-bottom-msg" v-else-if="item.categoryBig === 'TEXT'">文本信息</span>
                  <span class="single-bottom-msg" v-else>暂无消息</span>
                </p>
              </div>
            </div>
          </li>
        </ul>
        <div class="yqm-block" v-if="mediatorState" @click="openYQMDialog">
          <img src="@/assets/images/yqm.png"/>
          邀请码查阅
        </div>
      </div>
      <div class="chat-content-right" v-if="isClosed">
        <chat-main ref="chatmain" v-if="roomId && allDataList && currentRoomId" :roomId="roomId" :dataList="allDataList"
                   :currentRoomId="currentRoomId" :isClosed="isClosed" :privateState="privateState"></chat-main>
      </div>
      <div class="chat-content-right" v-else>
        <chat-main ref="chatmain" v-if="wsLink && roomId && allDataList && currentRoomId" :wsLink="wsLink"
                   :roomId="roomId" :dataList="allDataList" :currentRoomId="currentRoomId" :isClosed="isClosed"
                   :memberHeaderUrl="memberHeaderUrl" :privateState="privateState"></chat-main>
      </div>
    </div>
    <el-dialog title="受邀人邀请码查阅" :visible.sync="dialogYQMVisible" center>
      <el-table :data="dsrData" border>
        <el-table-column property="role" label="角色" width="120"></el-table-column>
        <el-table-column property="userName" label="姓名"></el-table-column>
        <el-table-column property="mobilePhone" label="手机号" width="120"></el-table-column>
        <el-table-column property="inviteCode" width="100" label="邀请码"></el-table-column>
        <el-table-column property="idCard" label="提交身份证" width="170"></el-table-column>
        <el-table-column property="realName" width="80" label="提交姓名"></el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
        :visible.sync="showYQDialog"
        width="45%"
        title="邀请人"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        center>
      <el-form :model="yqForm" :rules="yqRules" ref="yqForm" label-width="180px" class="demo-ruleForm" label-position="right">
        <el-form-item label="身份类型" prop="roleType">
          <el-select v-model="yqForm.roleType" style="width:220px" placeholder="请选择" value-key="code">
            <el-option
                v-for="item in yqForm.typeroleoptions"
                :key="item.code"
                :label="item.name"
                :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="委托权限" prop="agentType" v-if="yqForm.roleType == 'APPLICANT_AGENT' || yqForm.roleType == 'RESPONDENT_AGENT'">
          <el-radio-group v-model="yqForm.agentType" style="width: 200px">
            <el-radio :label="'GENERAL_AGENT'">一般授权</el-radio>
            <el-radio :label="'PRIVILEGE_AGENT'">特别授权</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="代理人身份" prop="agentPersonType" v-if="yqForm.roleType == 'APPLICANT_AGENT' || yqForm.roleType == 'RESPONDENT_AGENT'">
          <el-input class="yqInput" maxlength="50" v-model="yqForm.agentPersonType"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input class="yqInput" maxlength="11" v-model="yqForm.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input class="yqInput" v-model="yqForm.phone" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idCard" v-if="yqForm.needRealname">
          <el-input class="yqInput" maxlength="18" v-model="yqForm.idCard"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="yqForm.sex" style="width: 200px">
            <el-radio :label="'男'">男</el-radio>
            <el-radio :label="'女'">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否需要实名认证后参与">
          <el-radio-group v-model="yqForm.needRealname"
                          style="width: 200px">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="BtnLoading" @click="submitYQ">邀请</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import AlertEmit from './alertEmit'
import chatMain from './chatMain.vue'
import {
  intoMediationRoom,
  getHeadPortraitUrlList, addMeetingPerson
} from '@/api/casespace.js'
import config from '@/config/config.js'
import {
  getStore,
  dateformat, checkPhone, checkIdCard, toastSuc, toastError
} from '@/utils/utils.js'
import {
  userButton
} from "@/common/js/buttonMixin.js"
import {getAllMeetingUserInviteCode} from '@/api/meeting.js'
import Vue from "vue";

export default {
  components: {
    chatMain
  },
  props: ['bizRoomId'],
  mixins: [userButton],
  data() {
    return {
      spaceType: 0, // 默认0  0异步庭审   1异步调解   2在线送达
      isWorker: false,
      singleChatLists: [],
      isLoading: false,
      BtnLoading: false,
      wsLink: null,
      flk: "",
      currentRoomId: null, //当前聊天窗口的房间号
      meeetingId: 1,
      groupChatList: {},
      groupMemberCount: 0,
      linkFlag: false,
      previousRoomId: "",
      allDataList: "",
      loginInfouser: "",
      currentSingleContactor: "1",
      heartbeatFun: '',
      memberHeaderUrl: [], //存放聊天室的头像url
      closeRoomStatus: false,
      documentType: {
        'MEDIATION_RECORD': '笔录',
        // 'MEDIATION_BOOK': '调解协议书',
        // 'NO_DISSENT_MEDIATION_SCHEME': '无异议调解方案',
        // 'UNDISPUTED_FACT': '无争议事实确认协议',
      },
      roomId: '',
      isClosed: false,
      dialogYQMVisible: false,
      dsrData: [],
      mediatorState: false,
      privateState: false,
      showYQDialog: false, //邀请
      yqForm: {
        typeroleoptions: [{name: '申请人', code: 'APPLICANT'}, {name: '申请人代理人', code: 'APPLICANT_AGENT'}, {
          name: '被申请人',
          code: 'RESPONDENT'
        }, {name: '被申请人代理人', code: 'RESPONDENT_AGENT'}],
        roleType: '',
        name: '',
        phone: '',
        idCard: '',
        sex: '',
        agentType: '',
        agentPersonType: '',
        needRealname: true,
      },
      yqRules: {
        roleType: [
          {required: true, message: '请选择身份类型', trigger: 'change'}
        ],
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'}
        ],
        sex: [
          {required: true, message: '请选择性别', trigger: 'change'}
        ],
        agentType: [
          {required: true, message: '请选择授权权限', trigger: 'change'}
        ],
        agentPersonType: [
          {required: true, message: '请输入代理人身份', trigger: 'blur'}
        ],
        idCard: [
          {required: true, validator: checkIdCard, trigger: 'blur'}
        ],
        phone: [
          {required: true,validator: checkPhone, trigger: 'blur'}
        ],
      },
    }
  },
  filters: {
    dateFormat(time) {
      let date = new Date(time);
      return dateformat(date, 'hh:mm');
    }
  },
  created() {
    if (this.$route.query.spaceType) {
      this.spaceType = Number(this.$route.query.spaceType)
    }
    this.flk = getStore('flk');
    this.loginInfouser = JSON.parse(getStore('loginInfo'));
  },
  mounted() {
    let loginInfouser = JSON.parse(getStore('loginInfo'));
    if (loginInfouser.hasOwnProperty('personType') && loginInfouser.personType == 'STAFF') {
      this.mediatorState = true
    }
    this.intoMediationRoom()
  },
  watch: {
    '$route'() {
      if (this.$route.query.activeName == 'first') {
        this.intoMediationRoom()
      }
    }
  },
  methods: {
    intoMediationRoom(flag) {
      let option = {
        bizRoomId: this.$route.query.meetingid
      }
      console.log(option)
      intoMediationRoom(option).then((res) => {
        if (res.data.code === 1000) {
          this.singleChatLists = []
          let dataList = res.data.data,
              groupChatListMsg = res.data.data.groupChatMsg
          this.allDataList = dataList
          this.isClosed = dataList.roomStatus === 'END' ? true : false
          // this.$emit('isclose', this.isClosed)
          this.currentRoomId = this.allDataList.roomId
          this.groupMemberCount = dataList && dataList.memberCount
          this.meeetingId = Number(dataList.bizRoomId)
          if (groupChatListMsg.categoryBig) {
            if (groupChatListMsg.categoryBig != 'TEXT') {
              groupChatListMsg.lastMessageContent = JSON.parse(groupChatListMsg.lastMessageContent)['fileName']
            }
          } else {
            groupChatListMsg.lastMessageContent = ''
          }
          this.roomId = dataList.roomId //先默认加入群聊的房间
          this.groupChatList = groupChatListMsg
          if (dataList && dataList.members.length) {
            dataList.members.forEach(element => {
              if (this.loginInfouser.memberId != element.memberId) {
                let elementOp = {
                  lastMessageContent: (element.categoryBig == null || element.categoryBig == 'TEXT') ? element.lastMessageContent : JSON.parse(element.lastMessageContent)['fileName'],
                  memberName: element.memberName,
                  unreadMessageCount: element.unreadMessageCount,
                  lastMessageTime: element.lastMessageTime,
                  isFacialVerify: element.isFacialVerify,
                  roomId: element.roomId,
                  memberId: element.memberId,
                  headUrl: element.headUrl,
                  messageResource: element.messageResource,
                  categoryBig: element.categoryBig
                }
                this.singleChatLists.push(elementOp)
              }
            });
          }
          console.log('siliao--------', this.singleChatLists)
          if (!this.isClosed) {
            let wsInfo = this.$store.getters.getWSLink
            console.log(wsInfo)
            if (wsInfo.hasOwnProperty('wsLink')) {
              this.listenMessage(wsInfo.wsLink)
            } else {
              this.websocketEnterRoom()
            }
          }
          this.ApiGetHeadPortraitUrlList()
          AlertEmit.$emit('caseName', {
            caseName: dataList.causeName,
            bizRoomName: dataList.bizRoomName
          })
          this.isLoading = false
        } else {
          this.$message.error(res.data.message);
        }
      }, (erro) => {
        console.log(erro)
      })
    },
    //监听ws message
    listenMessage(ws) {
      let self = this
      self.wsLink = ws
      self.wsLink.onmessage = (evt) => {
        let res = JSON.parse(evt.data)
        if (res.event === "SEND_BOOK") {
          self.showChatMsgList(res.data)
        }
        if (res.event === "BROADCAST_MESSAGE") { //获取房间信息
          self.showChatMsgList(res.data)
        }
        if (res.event === "ROOM") { //获取房间信息

          // self.memberHeaderUrl = res.data.membersMap
        }
        if (res.event == "OTHER") {
          let typeEvent = JSON.parse(res.data).event
          if (typeEvent === 'SEND_MATERIAL') {
            //删除材料刷新案件空间聊天记录
            self.$refs.chatmain.initGroupMsg()
            self.$refs.chatmain.initPrivateMsg()
          }
        }
        if (res.event === "CLOSE_MEDIATION_ROOM" && this.currentRoomId === res.data.roomId) { //收到法官结束的请求
          self.$emit('handleIsClosed', true)
        }
        if (res.event != "LEAVE_ROOM") {
          console.log('$$$', res.event)
          self.$refs.chatmain.enterRoom(res)
        }
      }
      this.wsLink.onclose = (evt) => {
        if (!this.closeRoomStatus) {
          this.websocketEnterRoom()
        }
      }
    },
    ApiGetHeadPortraitUrlList() {
      getHeadPortraitUrlList({
        id: this.$route.query.meetingid
      }).then((res) => {
        if (res.data.code === 1000) {
          let ques = {};
          res.data.data.list.forEach(item => {
            ques[item.userId] = {
              headPortraitUrl: item.headPortraitUrl
            }
          })
          this.memberHeaderUrl = ques
        }
      }, (erro) => {
      })
    },
    closeInstantChat() { // 路由跳转时结束websocket链接
      clearInterval(this.heartbeatFun)
      let data = {
            roomId: this.currentRoomId,
            bizRoomId: this.bizRoomId,
          },
          msgdata = {};
      msgdata.event = "LEAVE_ROOM";
      msgdata.data = data;
      if (this.wsLink) {
        this.wsLink.send(JSON.stringify(msgdata) || '')
        this.wsLink.close()
      }
      this.closeRoomStatus = true
    },
    closeMediationRoom() { //主id是群聊的id
      let data = {
            roomId: this.roomId
          },
          msgdata = {};
      msgdata.event = "CLOSE_MEDIATION_ROOM";
      msgdata.data = data;
      this.wsLink.send(JSON.stringify(msgdata))
    },
    //创建新的联系人刷新联系人列表
    refreshContactList() {
      this.intoMediationRoom(this.currentSingleContactor)
    },
    websocketEnterRoom() {
      let self = this
      self.$store.dispatch('initWSLink', {
        currentRoomId: self.currentRoomId
      }).then(r => {
        console.log('#####看一看', r)
        self.listenMessage(r)
      })

    },
    //获取回来的单条聊天数据
    showChatMsgList(singleMsg) {
      console.log('singleMsg:', singleMsg)
      console.log(this.roomId)
      let self = this,
          copyGroupChatList = {
            ...self.groupChatList
          }
      if (typeof (singleMsg) == 'string') {
        singleMsg = JSON.parse(singleMsg)
        console.log("@@@@@", singleMsg)
      }
      console.log(this.singleChatLists)
      this.singleChatLists.map((element, index) => {
        if (element.roomId == singleMsg.roomId) {
          element.lastMessageContent = singleMsg.messageType == 'TEXT' ? singleMsg.messageContent : singleMsg.fileName
          element.lastMessageTime = singleMsg.createTime,
              element.categoryBig = singleMsg.categoryBig,
              element.messageResource = singleMsg.messageResource,
          (self.currentRoomId != singleMsg.roomId) && (element.unreadMessageCount = element.unreadMessageCount + 1)
          this.$set(this.singleChatLists, index, element)
        }
      })
      if (singleMsg.roomId == self.roomId) {
        // (self.currentRoomId != singleMsg.roomId) && (copyGroupChatList.unreadMessageCount = copyGroupChatList.unreadMessageCount + 1)
        // copyGroupChatList.lastMessageTime = singleMsg.createTime
        // copyGroupChatList.memberName = singleMsg.sender.memberName
        // copyGroupChatList.messageResource = singleMsg.messageResource
        // copyGroupChatList.categoryBig = singleMsg.categoryBig
        // copyGroupChatList.lastMessageContent = singleMsg.messageType == 'TEXT' ? singleMsg.messageContent : JSON.parse(singleMsg.messageContent)['fileName']
        // self.groupChatList = copyGroupChatList
        // this.$refs.chatmain.initGroupMsg()
      }
      this.singleChatLists = this.singleChatLists.sort(function (a, b) {
        return b.lastMessageTime - a.lastMessageTime;
      })
    },
    //心跳事件
    heartbeat() {
      var self = this;
      console.log('######')
      self.wsLink.send(JSON.stringify({
        event: 'HEARTBEAT'
      }))
    },
    //加入房间
    joinRoom(roomId) {
      console.log('roomId', roomId)
      console.log('roomId', this.groupChatList)
      if (this.currentRoomId == this.groupChatList.roomId) {
        this.groupChatList.unreadMessageCount = 0
      }
      let data = {
        roomId
      };
      let msgdata = {};
      msgdata.event = "JOIN_ROOM";
      msgdata.data = data;
      this.wsLink.send(JSON.stringify(msgdata))
    },
    openChatWindow(item) {
      console.log('info:', item)
      if (this.groupChatList == item.roomId) {
        this.groupChatList.unreadMessageCount = 0
        this.currentRoomId = this.allDataList.roomId
      } else {
        this.singleChatLists.forEach(element => {
          if (element.roomId == item.roomId) {
            element.unreadMessageCount = 0
          }
        })
        this.currentRoomId = item.roomId
      }
      if (item.hasOwnProperty('members')) {
        this.privateState = false
        this.$forceUpdate()
      } else {
        this.privateState = true
        this.$forceUpdate()
      }
      this.currentSingleContactor = item
      if (this.linkFlag) {
        this.joinRoom(item.roomId)
      }
    },
    openYQMDialog() {
      getAllMeetingUserInviteCode({id: this.$route.query.meetingid}).then((res) => {
        if (res.data.code == 1000) {
          this.dsrData = res.data.data
        }
        this.dialogYQMVisible = true
      })
    },
    submitYQ() {
      this.$refs['yqForm'].validate((valid) => {
        if (valid) {
          let spaceType = this.$route.query.spaceType
          let mediationMeetingType = (spaceType==1? 'ASYNCHRONOUS_MEDIATE' : (spaceType==2? 'ONLINE_SERVICE' : 'ASYNCHRONOUS_TRIAL'))
          let params = {
            meetingId: this.$route.query.meetingid,
            phone: this.yqForm.phone,
            name: this.yqForm.name,
            sex: this.yqForm.sex,
            agentType: this.yqForm.agentType,
            agentPersonType: this.yqForm.agentPersonType,
            meetingUserType: this.yqForm.roleType,
            mediationMeetingType: mediationMeetingType,
            authStatus:this.yqForm.needRealname?0:1
          }
          if (this.yqForm.needRealname) {
            params.idCard = this.yqForm.idCard
          }
          this.BtnLoading = true
          addMeetingPerson(params).then(res => {
            this.BtnLoading = false
            if (res.data.code === 1000) {
              if(res.data.message){
                toastError(res.data.message)
                return
              }else{
                toastSuc('邀请成功')
              this.showYQDialog = false
              this.yqForm.roleType = ''
              this.yqForm.name = ''
              this.yqForm.phone = ''
              this.yqForm.idCard = ''
              this.intoMediationRoom()
              }
            } else {
              toastError('邀请失败')
              return
            }

          })
        }
      })

    }
  }
}
</script>

<style lang="scss">
.micro-chat {
  background-color: #fff;

  .menu-taps .el-tabs__header {
    padding-top: 0 !important;
  }

  .chat-header {
    min-height: 50px;
    box-sizing: border-box;
    border-bottom: 1px solid #d8d8d8;
    font-size: 16px;
    color: #333;
    overflow: hidden;
    padding: 0 16px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f3f7fb;

    .chat-header-invite {
      display: flex;
      align-items: center;
      color: #1e6dcb;
      cursor: pointer;

      .connect-icon {
        width: 23px;
        height: 16px;
        margin-right: 5px;
      }
    }
  }

  .chat-content {
    display: flex;
    border: 1px solid #e1e1e1;

    .chat-content-left {
      width: 450px;
      box-sizing: border-box;
      border-right: 1px solid #d8d8d8;
      position: relative;

      .chat-content-list {
        overflow-y: auto;

        .chat-single-list {
          cursor: pointer;
          height: 60px;
          border-bottom: 1px solid #d8d8d8;
          padding-top: 10px;
          padding-bottom: 10px;
          padding: 14px 16px 6px;

          .single-list-top {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .single-list-topinner {
              display: flex;
              height: 25px;
              align-items: center;
            }

            .single-top-name {
              color: #666666;
              font-size: 16px;
              max-width: 160px;
            }

            .single-top-real {
              padding: 0 8px;
              font-size: 14px;
              margin-left: 10px;
              color: #fff;
              background-color: #2d9f3d;
              box-shadow: 0px 7px 15px 1px rgba(45, 159, 61, 0.5);
              border-radius: 20px;
            }

            .single-top-noreal {
              padding: 0 8px;
              font-size: 14px;
              margin-left: 10px;
              color: #999;
              background-color: #d8d8d8;
              border-radius: 20px;
            }

            .single-top-time {
              font-size: 16px;
              color: #666666;
              float: right;
            }

          }

          .single-list-bottom {
            margin-top: 10px;

            .single-bottom-number {
              margin-right: 8px;
              display: inline-block;
              width: 22px;
              height: 22px;
              border-radius: 50%;
              line-height: 22px;
              text-align: center;
              background-color: #0090f0;
              color: #fff;
            }

            .single-bottom-msg {
              position: relative;
              top: 5px;
              color: #999;
              font-size: 14px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              display: inline-block;
              width: 90%;
            }

            .single-bottom-groupmsgname {
              color: #999;
              font-size: 14px;
            }

            .single-bottom-groupmsg {
              margin-left: 6px;
              color: #999;
              font-size: 14px;
              overflow: hidden;
              line-height: 12px;
              text-overflow: ellipsis;
              white-space: nowrap;
              display: inline-block;
              width: 55%;
            }
          }

          .single-list-bottom1 {
            display: flex;
            align-items: center;

            .single-bottom-msg {
              top: 0;
            }
          }

          .single-flex {
            display: flex;
            align-items: center;
          }
        }

        .chat-single-outer {
          display: flex;

          .chat-single-le {
            display: flex;
            align-items: center;
            width: 20%;

            .single-top-avatar {
              display: block;
              width: 50px;
              height: 50px;
              margin-right: 6px;
              border-radius: 100%;
            }
          }

          .chat-single-ri {
            box-sizing: border-box;
            width: 80%;
            padding-left: 8px;
          }
        }

        .select-single-list {
          background-color: #f2f5f7;
        }
      }

      .yqm-block {
        padding-top: 3px;
        width: 26px;
        height: 130px;
        position: absolute;
        right: 0;
        bottom: 60px;
        word-wrap: break-word;
        text-align: center;
        cursor: pointer;
        background: #F3F6F9;
        font-size: 14px;
        color: #C8D9ED;
        border-radius: 10px 0 0 10px;

        img {
          width: 22px;
        }
      }
    }

    .chat-content-right {
      width: 100%;
    }
  }

  .yqInput {
    width: 220px;
  }
}
</style>
